import dummyResponse from "./dummyResponse";
import dummyRequest from "./dummyRequest";
import instance from "./instance";
import { buildErrorResponse } from "../../../components/errors/httpErrorPriority";

export default class Connector {
  searchEmail = (callback, params) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner",
      method: "get",
      params: params,
      headers: headers,
    };
    //callback(dummyResponse.level_certified);
    //callback(dummyResponse.otherContact);

    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({
              isError: true,
              ...response.data,
              httpStatus: response.status,
            });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          const error = buildErrorResponse(e);
          callback(error);
          // if (e?.response) {
          //   const status = e.response && e.response.status;
          // }

          // e.response && e.response.data
          //   ? callback({
          //       isError: true,
          //       ...e.response.data,
          //       httpStatus: status,
          //     })
          //   : callback({ isError: true, httpStatus: status });
        }
      });
  };

  updatePartnerInfo = (callback, body, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId,
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    //callback('');
    //callback(dummyResponse.statusCheckComplete);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // e.response && e.response.data
          //   ? callback({ isError: true, message: e.response.data.message })
          //   : null;
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  // fetchContacts = (callback, accountId, params = {}) => {
  //     const headers = { "Cache-Control": "no-cache", 'Authorization': 'Bearer ' + window.adobeIMS.getAccessToken().token, 'x-api-key': "exchange_spr" }
  //     const config = {
  //         'url': '/v1/apc/partner/' + accountId + '/contacts',
  //         'method': 'get',
  //         'params': params,
  //         'headers': headers
  //     }
  //         .then(response => {
  //             if (typeof (callback) === 'function') {
  //                 if (response.status === 200) {
  //                     callback(response.data);
  //                 }
  //                 else {
  //                     callback({ "isError": true });
  //                 }
  //             }
  //         })
  //         .catch(e => {
  //
  //             if (typeof (callback) === 'function') {
  //                 callback({ "isError": true });
  //             }
  //         });
  // }

  createContact = (callback, body, accountId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/partner/" + accountId + "/contact",
      method: "post",
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            // callback({ isError: true, message: response.data.message });
            const error = buildErrorResponse(e);
            callback(error);
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateContact = (callback, body, accountId, contactId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/partner/" + accountId + "/contact/" + contactId,
      method: "put",
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateLevel = (callback, body, accountId, params) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/membership",
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    //callback(dummyResponse.membershipId_AccId_0015Y00002nBCXrQAO);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // const errMsg =
          //   e?.response?.data?.message ||
          //   "Cannot create new partnership request";
          // callback({ isError: true, message: errMsg });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  updateAnswers = (callback, body, accountId, params) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/questionnaire",

      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  fetchAnswers = (callback, accountId, params) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/questionnaire",
      method: "get",
      params: params,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  getTnC = (callback, level) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/terms",
      method: "get",
      params: { level: level },
      headers: headers,
    };
    //callback({"allTerms" : TnC[country === 'US' ? 'en_US' : 'de_DE']});
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data.terms);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  fetchContacts = (callback, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/contacts",
      method: "get",
      params: params,
      headers: headers,
    };
    //callback(dummyResponse.fetchContactWithCoC);
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  deleteContact = (callback, accountId, contactId) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/contact/" + contactId,
      method: "delete",
      headers: headers,
    };
    //window.setTimeout(callback,3000,{"isError": true,"message":"some error"})
    // callback();
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  validateCertifiedContacts = (callback, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/apc/partner/" + accountId + "/validate/certifiedcontacts",
      method: "get",
      params: params,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  uplevelRenewPartner = (callback, body, accountId, params = {}) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/v1/APC/partner/" + accountId + "/membership",
      method: "put",
      params: params,
      data: body,
      headers: headers,
    };
    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, message: response.data.message });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // e.response && e.response.data
          //   ? callback({ isError: true, message: e.response.data.message })
          //   : null;
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };

  getCOCRegion = (callback) => {
    const headers = {
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + window.adobeIMS.getAccessToken().token,
      "x-api-key": "exchange_spr",
    };
    const config = {
      url: "/api/v1/spp/partner/config/coc-region",
      method: "get",
      params: {},
      headers: headers,
    };

    instance
      .request(config)
      .then((response) => {
        if (typeof callback === "function") {
          if (response.status === 200) {
            callback(response.data);
          } else {
            callback({ isError: true, ...response.data });
          }
        }
      })
      .catch((e) => {
        if (typeof callback === "function") {
          // e.response && e.response.data
          //   ? callback({ isError: true, ...e.response.data })
          //   : callback({ isError: true });
          const error = buildErrorResponse(e);
          callback(error);
        }
      });
  };
}
